import type { Action, ThunkAction } from "@reduxjs/toolkit";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { myApi } from "./api";
import { easebuzzApi } from "./easebuzzAPi";
import { vaamozApi } from "./vaamozApi";
import merchantsDetailSlice from "./slice/merchantsDeatils";
import amountDetailSlice from "./slice/amountSlice";
import paymentSlice from "./slice/paymentSlice";
import cardSlice from "./slice/cardSlice";
import linkSlice from "./slice/generateLinkSlice";
import appState from "./slice/appState";
import paymentStatusSlice from "./slice/paymentStatusSlice";
import upiSlice from "./slice/upiSlice";
import upiTransaction from "./slice/upiTransaction";

const rootReducer = combineReducers({
  [myApi.reducerPath]: myApi.reducer,
  [easebuzzApi.reducerPath]: easebuzzApi.reducer,
  [vaamozApi.reducerPath]: vaamozApi.reducer,
  merchantsDetail: merchantsDetailSlice,
  amountDetail: amountDetailSlice,
  paymentSlice: paymentSlice,
  cardSlice: cardSlice,
  paymentlinkSlice: linkSlice,
  appState: appState,
  paymentStatusSlice: paymentStatusSlice,
  upiSlice: upiSlice,
  upiTransaction,
});

export type RootState = ReturnType<typeof rootReducer>;

export const makeStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        myApi.middleware,
        easebuzzApi.middleware,
        vaamozApi.middleware
      ),
  });
};

export const store = makeStore();

export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore["dispatch"];
export type AppThunk<ThunkReturnType = void> = ThunkAction<
  ThunkReturnType,
  RootState,
  unknown,
  Action
>;
